import { Fragment } from "react";
import { useIntl } from "react-intl";
import Typography from "@mui/material/Typography";
import tuva from "@/i18n/definitions/tuva";
import { PropTypes } from "prop-types";
import { filter, pathEq, toLower } from "ramda";
import Opiskelijamaarat from "@/components/03-templates/HtmlLupanakyma/Opiskelijamaarat";

export default function TuvaOppilasOpiskelijamaaratYms({
  maaraykset,
  parentKoulutusmuoto
}) {
  const { formatMessage } = useIntl();

  const maaratVuodetMaaraykset = filter(
    pathEq(["kohde", "tunniste"], "opiskelijamaarat"),
    maaraykset
  );

  return !maaratVuodetMaaraykset || !maaratVuodetMaaraykset.length ? (
    <Fragment>
      <Typography component="h3" variant="h3">
        {formatMessage(tuva.oppilasOpiskelijamaaratYmsMaaratystiTitle)}
      </Typography>

      <p>
        {formatMessage(tuva.oppilasOpiskelijamaaratYmsMaaratysti, {
          koulutusmuoto: toLower(parentKoulutusmuoto.genetiivi)
        })}
      </p>
    </Fragment>
  ) : (
    <Opiskelijamaarat maaraykset={maaraykset} />
  );
}

TuvaOppilasOpiskelijamaaratYms.propTypes = {
  maaraykset: PropTypes.array,
  parentKoulutusmuoto: PropTypes.object
};
